import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import { useUser } from "../../../functions/userContext";
import { useAppTheme } from "../../themes/appThemeProvider";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import GaugeLogo from "../../../assets/gauge.png";
import logo from "../../../assets/cloudguage-logo.png";
import logoBlack from "../../../assets/cloudguage-logo-black.png";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import styles from "./appBar.module.css";

const usePageTitle = () => {
  const location = useLocation();
  const { currentTab } = useUser();
  const [title, setTitle] = useState("Home");

  useEffect(() => {
    const map = {
      "/assets/ec2View": "EC2 ASSETS",
      "/system-info": "System Information Dashboard",
      "/monitoring": "MONITORING",
      "/costs": "CLOUD COSTS",
      "/admin/manualUpdate": "DATA ENTRY",
      "/security/tenable": "SECURITY VULNERABILITIES",
      "/reports/weeklyReports": "WEEKLY REPORTS",
      "/jira": "JIRA ANALYSIS",
      "/reports/reportBuilder": "AGENTIC BUILDER",
    };
    const baseTitle = map[location.pathname] || "KPI SUMMARY";
    setTitle(currentTab ? `${baseTitle} - ${currentTab.toUpperCase()}` : baseTitle);
  }, [location.pathname, currentTab]);

  return title;
};

export const CustomAppBar = ({ children, childIcons }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const pageTitle = usePageTitle();

  const toggleExpand = () => setToolsOpen((prev) => !prev);

  const {
    user,
    ROLE_CONFIG,
    checkAccess,
    getFormattedName,
    toolsOpen: expanded,
    setToolsOpen: setToolsOpen,
    showTabs,
  } = useUser();
  const userMenuRef = useRef(null);

  return (
    <Box>
      <AppBar
        variant="div"
        position="fixed"
        className={styles.appBar}
        sx={{ backgroundColor: (theme) => theme.palette.background.accent, zIndex: 8 }}
      >
        <Toolbar
          className={styles.appBar}
          sx={{
            justifyContent: "space-between",
            backgroundColor: (theme) => theme.palette.background.accent,
          }}
        >
          <Box className={styles.appBarContainer}>
            <Box className={styles.gaugeLogo} sx={{}}>
              <Box
                component="img"
                src={isDark ? GaugeLogo : GaugeLogo}
                alt="Cloud Gauge Logo"
                sx={{
                  height: 45,
                  width: "auto",
                  transition: "filter 0.3s",
                  filter: (theme) => `brightness(${theme.palette.mode === "dark" ? 1 : 0.8})`,
                }}
              />
            </Box>

            {/* Title */}
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  ml: 2,
                  color: (theme) => theme.palette.text.primary,
                  marginLeft: "26px",
                }}
              >
                {pageTitle}
              </Typography>
            </Box>
            {/* Gauge Header */}
            <Box
              sx={{
                flex: 1,
                alignItems: "center",
                display: "flex",
                left: "-20px",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {!showTabs && (
                <Box
                  component="img"
                  src={isDark ? logo : logoBlack}
                  alt="Cloud Gauge Logo"
                  sx={{
                    height: 45,

                    width: "auto",
                    transition: "filter 0.3s",
                    filter: (theme) => `brightness(${theme.palette.mode === "dark" ? 1 : 0.8})`,
                  }}
                />
              )}
            </Box>
            <Box sx={{ flex: 1 }}></Box>
          </Box>
          <Box
            className={expanded ? styles.toolBoxExpanded : styles.toolBox}
            sx={{ width: expanded ? "280px" : 40, paddingLeft: expanded ? "10px" : "0px" }}
          >
            {expanded && (
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: "bold",
                  color: theme.palette.text.primary,

                  flex: 1,
                  transition: "opacity 0.3s ease-in-out",
                }}
              >
                Tools
              </Typography>
            )}
            <IconButton
              sx={{
                color: theme.palette.text.primary,
                mr: 0.5,
                p: 0.5,
                "& svg": {
                  transition: "transform 0.2s, color 0.2s",
                },
                "&:hover svg": {
                  transform: "scale(1.2)",
                  color: "#C14D41",
                },
              }}
              disableRipple
              size="small"
              onClick={toggleExpand}
            >
              {expanded ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};
